import { useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { Select, Skeleton } from 'antd';
import { Conditional } from 'components/conditional/conditional';
import { setKringloopwijzerId } from 'helpers/api';
import { refreshCallContext } from 'helpers/queries/call-context';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { KlwMenu } from '../types/menu';

interface YearSelectorProps {
  menu: UseQueryResult<KlwMenu>;
}
export const YearSelector: FC<YearSelectorProps> = ({ menu }) => {
  const nav = useNavigate();
  const queryClient = useQueryClient();

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', height: 84 }}>
        <Conditional condition={!menu?.isLoading}>
          <span style={{ textAlign: 'left', lineHeight: '30px', height: 30 }}>Bedrijfsnaam: {menu?.data?.bedrijfsnaam}</span>
          <span style={{ textAlign: 'left', lineHeight: '30px', height: 30 }}>
            Jaar:{' '}
            <Select
              onChange={val => {
                setKringloopwijzerId(val);
                refreshCallContext(queryClient);
                nav('/');
              }}
              value={parseFloat(localStorage.getItem('KringloopwijzerId'))}
              style={{ width: '150px' }}
              options={menu?.data?.kringloopwijzers?.map(kringloopwijzer => ({ value: kringloopwijzer.id, label: kringloopwijzer.jaarItem }))}
            />
          </span>
        </Conditional>
        <Conditional condition={menu?.isLoading}>
          <Skeleton.Button style={{ width: '300px' }} active />
          <Skeleton.Button style={{ width: '300px', marginTop: '-30px' }} active />
        </Conditional>
      </div>
    </>
  );
};
